"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Row = void 0;
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
require("./Row.scss");
const Row = _ref => {
  let {
    children,
    hasHover,
    isWithArrows,
    isLabel,
    isPrimary,
    isHighlighted,
    style,
    className
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)('cds-ComparisonTableRow', {
      'cds-ComparisonTableRow--WithHover': hasHover,
      'cds-ComparisonTableRow--WithArrows': isWithArrows,
      'cds-ComparisonTableRow--Label': isLabel,
      'cds-ComparisonTableRow--Primary': isPrimary,
      'cds-ComparisonTableRow--Highlighted': isHighlighted
    }, className),
    style: style
  }, children);
};
exports.Row = Row;
//# sourceMappingURL=Row.js.map